import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "body-centerTEXT" }, " 仅需三步，即可发布大量商品视频 ", -1)
const _hoisted_3 = { class: "body-item" }
const _hoisted_4 = { class: "imgBox" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "body-bottom-button" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("立即开始")

import { ref, reactive } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  emits: ['updataShow'],
  setup(__props, { emit }) {

const store = useStore();

const threeText = ref([
    {
        count: 1, title: '建立商品AI视频模型', gords:
            [
                '上传5-10条商品拍摄视频',
                '输入商品信息',
                '即可完成商品AI视频模型构建'],
        img: 'https://cemetaxcx-pic-1313090634.cos.ap-beijing.myqcloud.com/AIvideoproduct/gif/step1.gif'

    },

    {
        count: 2, title: '生成大量商品视频', gords:
            [
                '选择生成数量',
                '等待视频生成'],
        img: 'https://cemetaxcx-pic-1313090634.cos.ap-beijing.myqcloud.com/AIvideoproduct/gif/step2.gif'
    },
    {
        count: 3, title: '生成平台发布文案', gords:
            [
                '点击生成视频',
                '匹配发布文案',
                '实现一键发布'],
        img: 'https://cemetaxcx-pic-1313090634.cos.ap-beijing.myqcloud.com/AIvideoproduct/gif/step3.gif'
    }
]);
const updataShow = () => {
    emit('updataShow', 'Generate');
    // store.state.comShow.componentsShow = 'Generate';
    store.commit('comShow/upDataShow', 'Generate');
};


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threeText.value, (v, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "body-item-box",
          key: v.count
        }, [
          _createElementVNode("h1", null, _toDisplayString(v.count), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: v.img,
              alt: ""
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", null, _toDisplayString(v.title), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.gords, (val, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "body-item-box-title"
            }, _toDisplayString(val), 1))
          }), 128))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_button, { onClick: updataShow }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ]))
}
}

})